import axios from '../helpers/axios'
import { logError } from '../services';
import { IDocumentTypeRes, IDocumentTypeUpdate } from '../models';

export const getDocumentTypes = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  name?: string;
}): Promise<IDocumentTypeRes> => {
  try {
    const { data } = await axios.get(`/api/document-types`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getDocumentTypes failed');
    return Promise.reject(error);
  }
};

export const createDocumentType = async (documentType: IDocumentTypeUpdate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/document-types`, documentType, { headers: { 'Content-Type': 'application/json' } });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          documentType
        }
      },
      'createDocumentType failed'
    );
    return error.response.data;
  }
};

export const updateDocumentType = async (id: number, documentType: IDocumentTypeUpdate): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/document-types/${id}`, documentType, { headers: { 'Content-Type': 'application/json' } });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          documentType
        }
      },
      'updateDocumentType failed'
    );
    return Promise.reject(error);
  }
};

export const deleteDocumentType = async (id: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/document-types/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteDocumentType failed');
    return Promise.reject(error);
  }
};
